<template>
    <v-row no-gutters>
        <template>
            <div class="p-4 mt-4">
                <v-alert text color="blue darken-4" class="rounded-lg d-flex align-content-center" elevation="2"
                    style="min-height: 230px;position: relative;">
                    <!-- <v-alert dismissible dense class="indigo--text text--darken-4 text-caption"  color="white" elevation="1">
                            <v-icon small color="indigo darken-4">mdi-information-outline</v-icon>
                            Jika data tidak sesuai, silakan ubah data profil melalui <a href="">tautan ini.</a>
                        </v-alert> -->
                    <div class="text-body-2 pl-5" style="color:#555; line-height: 1.5rem;">
                        <h5 class="black--text font-weight-black text-h5">Assalamualaikum, {{
                            user.name[0]
                        }}</h5>

                        <div v-if="kp == null">
                            <div class="text-body-2">{{ this.$t('info_not_register_yet') }}</div>
                            <v-btn class="mt-4" color="indigo white--text darken-4" :to="{ name: 'kp-create' }">
                                {{ this.$t('register') }}
                            </v-btn>
                        </div>
                        <div v-else-if="kp.level_aproval_sekarang == 1 && riwayat && riwayat[0].kode_status == 'SBD'">
                            <div class="text-body-2">Pengajuan kerja praktik ditolak perusahaan</div>
                            <div class=" mt-2">
                                <v-chip small label><v-icon left>
                                        mdi-file-eye
                                    </v-icon><strong>Kerja praktik ditolak perusahaan</strong></v-chip>
                            </div>
                            <v-btn class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-update', query: { update: kp.id } }">
                                Daftar ulang
                            </v-btn>
                        </div>
                        <div v-else-if="kp.level_aproval_sekarang == 1">
                            <div class="text-body-2">{{ this.$t('submission_on_verification_officer') }}</div>
                            <div class=" mt-2">
                                <v-chip small label><v-icon left>
                                        mdi-file-eye
                                    </v-icon><strong>{{ this.$t('waiting_for_verification') }}</strong></v-chip>
                            </div>
                            <v-btn class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-update', query: { update: kp.id } }">
                                {{ this.$t('edit') }}
                            </v-btn>
                            <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-read', query: { uuid: kp.id + '$' + generateRandomString(16) } }">
                                {{ this.$t('view') }}
                            </v-btn>
                        </div>
                        <div v-else-if="kp.level_aproval_sekarang == 3">
                            <div class="text-body-2">Pendaftaran kerja praktik anda perlu perbaikan.</div>
                            <div class=" mt-2">
                                <v-chip small color="red lighten-4" label><v-icon left>
                                        mdi-file-cog
                                    </v-icon><strong>Perlu perbaikan</strong></v-chip>
                            </div>
                            <v-btn class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-update', query: { update: kp.id } }">
                                Perbaiki
                            </v-btn>
                            <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-read', query: { uuid: kp.id + '$' + generateRandomString(16) } }">
                                Lihat
                            </v-btn>
                        </div>
                        <div v-else-if="kp.level_aproval_sekarang == 4 && riwayat && riwayat[0].kode_status == 'PD'">
                            <div class="text-body-2">Pendaftaran sudah diverifikasi.<br> Unduh surat pengantar ke perusahaan
                                <a :href="urlCetakSuratPengantar()" target="_blank">disini.</a>
                            </div>
                            <div class=" mt-2">
                                <v-chip small color="orange lighten-4" label><v-icon left>
                                        mdi-file-check
                                    </v-icon><strong>Pendaftaran diverifikasi</strong></v-chip>
                            </div>
                            <v-btn class="mt-4" color="indigo white--text darken-4" :to="{ name: 'kp-create' }">
                                Unggah surat balasan
                            </v-btn>
                            <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-read', query: { uuid: kp.id + generateRandomString(16) } }">
                                Lihat
                            </v-btn>
                        </div>
                        <div v-else-if="kp.level_aproval_sekarang == 4 && riwayat && riwayat[0].kode_status == 'SBPP'">
                            <div class="text-body-2">Surat balasan perlu perbaikan. <br>Catatan petugas: {{ kp.catatan }}
                            </div>
                            <div class=" mt-2">
                                <v-chip small color="red lighten-4" label><v-icon left>
                                        mdi-file-edit
                                    </v-icon><strong>{{ riwayat[0].status }}</strong></v-chip>
                            </div>
                            <v-btn class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-create', query: { update: kp.id } }">
                                Perbaiki surat balasan
                            </v-btn>
                            <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-read', query: { uuid: kp.id + generateRandomString(16) } }">
                                Lihat
                            </v-btn>
                        </div>
                        <div v-else-if="kp.level_aproval_sekarang == 4 && riwayat && riwayat[0].kode_status == 'MSB'">
                            <div class="text-body-2">Surat balasan anda sedang di verifikasi.</div>
                            <div class=" mt-2">
                                <v-chip small color="orange lighten-4" label><v-icon left>
                                        mdi-file-send
                                    </v-icon><strong>Menunggu verifikasi surat balasan</strong></v-chip>
                            </div>
                            <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-read', query: { uuid: kp.id + '$' + generateRandomString(16) } }">
                                Lihat
                            </v-btn>
                        </div>
                        <div v-else-if="kp.level_aproval_sekarang == 4">
                            <div class="text-body-2">Pendaftaran sudah diverifikasi.<br> Unduh surat pengantar ke perusahaan
                                <a :href="urlCetakSuratPengantar()" target="_blank">disini.</a>
                            </div>
                            <div class=" mt-2">
                                <v-chip small color="orange lighten-4" label><v-icon left>
                                        mdi-file-check
                                    </v-icon><strong>Pendaftaran diverifikasi</strong></v-chip>
                            </div>
                            <v-btn class="mt-4" color="indigo white--text darken-4" :to="{ name: 'kp-create' }">
                                Unggah surat balasan
                            </v-btn>
                            <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-read', query: { uuid: kp.id + generateRandomString(16) } }">
                                Lihat
                            </v-btn>
                        </div>
                        <div v-else-if="kp.level_aproval_sekarang == 7 && riwayat && riwayat[0].kode_status == 'ML'">
                            <div class="text-body-2">Beberapa dokumen sudah diunggah.</div>
                            <p>Silakan lengkapi dokumen yang belum diunggah.</p>
                            <div class=" mt-2">
                                <v-chip small color="green lighten-4" label><v-icon left>
                                        mdi-file-check
                                    </v-icon><strong>{{ riwayat[0].status }}</strong></v-chip>
                            </div>
                            <v-btn class="mt-4" color="indigo white--text darken-4" :to="{ name: 'kp-create' }">
                                Unggah laporan selesai
                            </v-btn>
                            <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-read', query: { uuid: kp.id + '$' + generateRandomString(16) } }">
                                Lihat
                            </v-btn>
                        </div>
                        <div v-else-if="kp.level_aproval_sekarang == 7">
                            <div class="text-body-2">Surat balasan sudah diverifikasi.<br>
                                Dokumen/laporan selesai bisa diunggah secara bertahap.</div>
                            <div class=" mt-2">
                                <v-chip small color="green lighten-4" label><v-icon left>
                                        mdi-file-check
                                    </v-icon><strong>{{ riwayat[0].status }}</strong></v-chip>
                            </div>
                            <v-btn class="mt-4" color="indigo white--text darken-4" :to="{ name: 'kp-create' }">
                                Unggah laporan selesai
                            </v-btn>
                            <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-read', query: { uuid: kp.id + '$' + generateRandomString(16) } }">
                                Lihat
                            </v-btn>
                        </div>
                        <div
                            v-else-if="kp.level_aproval_sekarang == 10 && riwayat && riwayat[0].kode_status == 'ML' && kp.nilai_angka == null">
                            <div class="text-body-2">Dokumen & Laporan selesai kerja praktik sedang di tinjau oleh
                                dosen.</div>
                            <div class=" mt-2">
                                <v-chip small color="green lighten-2" label><v-icon left>
                                        mdi-file-check
                                    </v-icon><strong>{{ riwayat[0].status }}</strong></v-chip>
                            </div>
                            <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                :to="{ name: 'kp-read', query: { uuid: kp.id + '$' + generateRandomString(16) } }">
                                Lihat
                            </v-btn>
                        </div>
                        <div v-else-if="kp.level_aproval_sekarang >= 10">
                            <div v-if="!checkBeritaAcara()">
                                <div class="text-body-2">Selamat <strong>Kerja Praktik</strong> anda sudah selesai & dosen
                                    sudah memberikan nilai.<br></div>
                                <h5>Nilai: <span class="font-weight-bold indigo--text text--darken-4" v-if="showNilai">{{
                                    $nilai.tampil(kp.nilai_angka, kp.nilai_huruf) }}</span> <span v-else>***</span> <v-icon @click="showNilai = !showNilai">{{
            showNilai ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                                </h5>
                                <div class=" mt-2">
                                    <v-chip small color="indigo darken-1" class="white--text" label><v-icon left>
                                            mdi-file-check
                                        </v-icon><strong>Selesai</strong></v-chip>
                                </div>
                                <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                    :to="{ name: 'kp-read', query: { uuid: kp.id + '$' + generateRandomString(16) } }">
                                    Lihat
                                </v-btn>
                            </div>
                            <div v-if="checkBeritaAcara()">
                                <div class="text-body-2">Kerja praktik anda selangkah lagi menuju selesai.<br><small>Unggah
                                        berita acara untuk menyelesaikan Kerja Praktik.</small></div>
                                <div class=" mt-2">
                                    <v-chip small color="blue darken-1" class="white--text" label><v-icon left>
                                            mdi-file-delimited
                                        </v-icon><strong>Menunggu unggah berita acara</strong></v-chip>
                                </div>
                                <v-btn class="mt-4" color="indigo white--text darken-4" :to="{ name: 'kp-create' }">
                                    Unggah berita acara
                                </v-btn>
                                <v-btn outlined class="mt-4" color="indigo white--text darken-4"
                                    :to="{ name: 'kp-read', query: { uuid: kp.id + '$' + generateRandomString(16) } }">
                                    Lihat
                                </v-btn>
                            </div>

                        </div>
                    </div>

                    <v-img v-if="kp == null" contain max-height="250" max-width="250" class="img-hero"
                        :src="'/images/hero-home.svg'"></v-img>

                </v-alert>
                <div v-if="kp !== null">
                    <v-stepper class="mb-4" v-model="timeline">
                        <v-stepper-header>
                            <v-stepper-step :complete="kp && kp.level_aproval_sekarang >= 1" step="1">
                                Daftar
                                <small>Unggah berkas pendaftaran</small>
                            </v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step :complete="kp && kp.level_aproval_sekarang >= 7" step="2">
                                Unggah surat balasan
                                <small>Surat balasan diterima/ditolak perusahaan</small>
                            </v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step :complete="kp && kp.level_aproval_sekarang > 7" step="3">
                                Unggah berkas selesai
                                <small>Unggah dokumentasi & Laporan</small>
                            </v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step :complete="kp && kp.level_aproval_sekarang >= 10 && !checkBeritaAcara()"
                                step="4">
                                Selesai
                            </v-stepper-step>
                        </v-stepper-header>
                    </v-stepper>

                    <v-row>
                        <h6 class="text-body-1 mt-3">Beranda</h6>
                        <v-col cols="12" md="6">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-card color="p-2" min-height="100" class="rounded-lg">
                                        <v-card-text class="d-flex justify-space-between align-center">
                                            <div class="row">
                                                <strong>Rencana mulai KP</strong>
                                                <small>{{ tanggal_rencana_mulai_kp }}</small>
                                            </div>
                                            <v-avatar tile color="indigo lighten-5" class="rounded-circle" size="60">
                                                <v-icon color="blue darken-3">mdi-calendar-edit</v-icon>
                                            </v-avatar>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-card color="p-2" min-height="100" class="rounded-lg">
                                        <v-card-text class="d-flex justify-space-between align-center">
                                            <div class="row">
                                                <strong>Rencana selesai KP</strong>
                                                <small>{{ tanggal_rencana_selesai_kp }}</small>
                                            </div>
                                            <v-avatar tile color="indigo lighten-5" class="rounded-circle" size="60">
                                                <v-icon color="blue darken-3">mdi-calendar-edit</v-icon>
                                            </v-avatar>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-card color="p-2" min-height="100" class="rounded-lg">
                                        <v-card-text class="d-flex justify-space-between align-center">
                                            <div class="row">
                                                <strong>Realisasi mulai KP</strong>
                                                <small>{{ tanggal_realisasi_mulai_kp }}</small>
                                            </div>
                                            <v-avatar tile color="indigo lighten-5" class="rounded-circle" size="60">
                                                <v-icon color="yellow darken-4">mdi-calendar</v-icon>
                                            </v-avatar>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-card color="p-2" min-height="100" class="rounded-lg">
                                        <v-card-text class="d-flex justify-space-between align-center">
                                            <div class="row">
                                                <strong>Realisasi selesai KP</strong>
                                                <small>{{ tanggal_realisasi_selesai_kp }}</small>
                                            </div>
                                            <v-avatar tile color="indigo lighten-5" class="rounded-circle" size="60">
                                                <v-icon color="green">mdi-calendar-check</v-icon>
                                            </v-avatar>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <v-card color="p-2" min-height="100" class="rounded-lg">
                                        <v-card-text class="d-flex justify-space-between align-center">
                                            <div class="row">
                                                <strong>Lama KP</strong>
                                                <small>{{ lama_kp }}</small>
                                            </div>
                                            <v-avatar tile color="indigo lighten-5" class="rounded-circle" size="60">
                                                <v-icon color="red darken-4">mdi-calendar-clock</v-icon>
                                            </v-avatar>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <h6 class="text-body-1 mt-5 mb-4" v-if="kp !== null && kp.level_aproval_sekarang >= 7">Dosen
                                pembimbing</h6>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-card>
                                        <v-card-text v-for="(item, i) in kp.dosen_pembimbing" :key="i"
                                            class="d-flex justify-content-between align-center">
                                            <v-row>
                                                <h6><strong>{{ item.name }}</strong></h6>
                                                <small>{{ item.email }}</small>
                                            </v-row>
                                            <v-avatar size="60" color="grey">
                                                <img v-if="!item.avatar" src="/images/user-profile.avif" :alt="item.name"
                                                    style="object-fit: cover;">
                                                <img v-if="item.avatar" :src="item.avatar" :alt="item.name"
                                                    style="object-fit: cover;">
                                            </v-avatar>
                                        </v-card-text>

                                    </v-card>
                                </v-col>

                            </v-row>
                            <h6 class="text-body-1 mt-5 mb-4" v-if="kp !== null && kp.level_aproval_sekarang >= 4">Dokumen
                                untuk
                                di unduh</h6>
                            <v-row v-if="kp !== null && kp.level_aproval_sekarang >= 4">
                                <v-col cols="12" md="12">
                                    <v-card class="p-3 mb-3 rounded-lg">
                                        <div
                                            v-if="kp !== null && kp.level_aproval_sekarang >= 4 && kp.level_aproval_sekarang < 7">
                                            <h6 class="mb-5 text-body-2 font-weight-bold ">Surat pengantar ke perusahaan
                                            </h6>
                                            <v-row class="mb-1">
                                                <a :href="urlCetakSuratPengantar()" target="_blank">
                                                    <v-alert dense right outlined color="blue darken-4"
                                                        icon="mdi-file-download"
                                                        class="card-file-download rounded-lg d-flex align-self-end">
                                                        <p class="m-0">pengantar_perusahaan.pdf</p>
                                                    </v-alert>
                                                </a>
                                            </v-row>
                                        </div>
                                        <div
                                            v-if="$isFTSP && kp !== null && kp.level_aproval_sekarang >= 4 && kp.level_aproval_sekarang >= 7">
                                            <h6 class="mb-5 text-body-2 font-weight-bold ">Surat konfirmasi penerimaan</h6>
                                            <v-row class="mb-1">
                                                <a :href="urlCetakSuratKonfirmasi()" target="_blank">
                                                    <v-alert dense right outlined color="blue darken-4"
                                                        icon="mdi-file-download"
                                                        class="card-file-download rounded-lg d-flex align-self-end">
                                                        <p class="m-0">konfirmasi_penerimaan.pdf</p>
                                                    </v-alert>
                                                </a>
                                            </v-row>
                                        </div>
                                        <div v-if="$isFTI && kp !== null && kp.level_aproval_sekarang >= 10">
                                            <h6 class="mb-5 text-body-2 font-weight-bold "> Berita acara</h6>
                                            <v-row class="mb-1">
                                                <a :href="urlBeritaAcara()">
                                                    <v-alert dense right outlined color="blue darken-4"
                                                        icon="mdi-file-download"
                                                        class="card-file-download rounded-lg d-flex align-self-end">
                                                        <p class="m-0">berita_acara.pdf</p>
                                                    </v-alert>
                                                </a>
                                            </v-row>
                                        </div>
                                        <div v-if="kp !== null && kp.level_aproval_sekarang >= 7">
                                            <h6 class="mb-5 text-body-2 font-weight-bold ">Surat tugas mahasiswa
                                            </h6>
                                            <v-row class="mb-1">
                                                <a :href="urlSuratTugasMahasiswa()">
                                                    <v-alert dense right outlined color="blue darken-4"
                                                        icon="mdi-file-download"
                                                        class="card-file-download rounded-lg d-flex align-self-end">
                                                        <p class="m-0">surat_tugas_mahasiswa.pdf</p>
                                                    </v-alert>
                                                </a>
                                            </v-row>
                                        </div>
                                        <div v-if="kp !== null && kp.level_aproval_sekarang >= 7">
                                            <h6 class="mb-5 text-body-2 font-weight-bold "> Lembar konsultasi</h6>
                                            <v-row class="mb-1">
                                                <a :href="$unduh.lembarKonsultasi()">
                                                    <v-alert dense right outlined color="blue darken-4"
                                                        icon="mdi-file-download"
                                                        class="card-file-download rounded-lg d-flex align-self-end">
                                                        <p class="m-0">lembar_konsultasi.docx</p>
                                                    </v-alert>
                                                </a>
                                            </v-row>
                                        </div>
                                        <div v-if="kp !== null && kp.level_aproval_sekarang >= 7">
                                            <h6 class="mb-5 text-body-2 font-weight-bold "> Logbook kegiatan</h6>
                                            <v-row class="mb-1">
                                                <a :href="$unduh.lembarKegiatan()">
                                                    <v-alert dense right outlined color="blue darken-4"
                                                        icon="mdi-file-download"
                                                        class="card-file-download rounded-lg d-flex align-self-end">
                                                        <p class="m-0">logbook_kegiatan.docx</p>
                                                    </v-alert>
                                                </a>
                                            </v-row>
                                        </div>
                                        <div v-if="kp !== null && kp.level_aproval_sekarang >= 7">
                                            <h6 class="mb-5 text-body-2 font-weight-bold ">Lembar penilaian pembimbing
                                                perusahaan</h6>
                                            <v-row class="mb-1">
                                                <a :href="$unduh.lembarPenilaianPembimbing()">
                                                    <v-alert dense right outlined color="blue darken-4"
                                                        icon="mdi-file-download"
                                                        class="card-file-download rounded-lg d-flex align-self-end">
                                                        <p class="m-0">lembar_penilaian.docx</p>
                                                    </v-alert>
                                                </a>
                                            </v-row>
                                        </div>
                                        <!-- <div v-if="kp !== null && kp.level_aproval_sekarang >= 7">
                                            <h6 class="mb-5 text-body-2 font-weight-bold ">Surat izin mahasiswa</h6>
                                            <v-row class="mb-1">
                                                <a :href="urlCetakSuratPengantar()">
                                                    <v-alert dense right outlined color="blue darken-4"
                                                        icon="mdi-file-download"
                                                        class="card-file-download rounded-lg d-flex align-self-end">
                                                        <p class="m-0">surat_izin_mahasiswa.pdf</p>
                                                    </v-alert>
                                                </a>
                                            </v-row>
                                        </div> -->
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" height="100%">
                            <template>
                                <v-stepper v-model="stepers" vertical class="rounded-lg">
                                    <h4
                                        class="text-body-1 font-weight-bold text-decoration-underline indigo--text text--darken-4 p-3">
                                        Riwayat pendaftaran</h4>
                                    <div v-for="(item, index) in riwayat">
                                        <v-stepper-content step="">

                                        </v-stepper-content>

                                        <v-stepper-step step="">
                                            <v-row justify="space-between">
                                                <v-col cols="7">
                                                    {{ item.status }} <br>
                                                    <small v-if="item.catatan_aproval">Catatan: {{ item.catatan_aproval
                                                    }}</small>
                                                </v-col>
                                                <v-col class="text-right" cols="5">
                                                    <small>{{ item.time }}<br>{{ item.date }}</small>
                                                </v-col>
                                            </v-row>
                                        </v-stepper-step>
                                    </div>

                                </v-stepper>
                            </template>
                        </v-col>
                    </v-row>
                </div>

            </div>
        </template>
    </v-row>
</template>
<script>
export default {
    data: () => ({
        showUnggahBeritaAcara: true,
        showNilai: false,
        dateNow: new Date(),
        tanggal_rencana_mulai_kp: '-',
        tanggal_realisasi_mulai_kp: '-',
        lama_kp: '-',
        tanggal_realisasi_selesai_kp: '-',
        userData: undefined,
        kp: null,
        riwayat: undefined,
        timeline: 1,
        stepers: 6,
        dates: '',
        menu: false,
        user: JSON.parse(localStorage.getItem("user")),
        items: [
            {
                text: 'Home',
                disabled: false,
                href: 'home',
            },
            {
                text: 'Pendaftaran',
                disabled: true,
                href: 'home-student',
            },
        ],
    }),
    created() {
        this.user ? this.user.name = this.user.name.split(" ") : '';
        this.getData();
    },
    methods: {
        getData() {
            this.axios.get("/api/mahasiswa/kp").then((res) => {
                this.userData = res.data.data;
                this.kp = this.userData.kp;
                console.log(this.kp, 'kp');
                if (this.kp.tanggal_rencana_mulai_kp && this.kp.tanggal_rencana_selesai_kp) {
                    this.tanggal_rencana_mulai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_rencana_mulai_kp);
                    this.tanggal_rencana_selesai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_rencana_selesai_kp)
                };
                if (this.kp.tanggal_realisasi_mulai_kp) {
                    let nows = new Date();
                    if (this.kp.tanggal_realisasi_selesai_kp) {
                        nows = this.kp.tanggal_realisasi_selesai_kp;
                    }
                    this.lama_kp = this.$dates.dateDiff(this.kp.tanggal_realisasi_mulai_kp, nows);
                    this.tanggal_realisasi_mulai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_realisasi_mulai_kp);
                }
                if (this.kp.tanggal_realisasi_selesai_kp) {
                    console.log('==============');
                    this.tanggal_realisasi_selesai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_realisasi_selesai_kp)
                };
                this.getRiwayat();
                this.getTimeline(this.kp.level_aproval_sekarang);
            })
                .catch((err) => console.log(err))
                .finally(() => console.log('log::getData() finished'));
        },
        checkBeritaAcara() {
            if (this.$isFTSP) return false;

            let exist = this.kp.laporan.find(x => x.kode_jenis_dokumen == 'D008').dokumen.length > 0;
            return !exist;
        },
        getRiwayat() {
            this.axios.get("/api/kp/" + this.kp.id + '/riwayat').then((res) => {
                this.riwayat = res.data.data.sort();
                if (this.riwayat) {
                    this.riwayat = this.riwayat.map(val => {
                        val.time = new Date(val.created_at).getHours() + ':' + new Date(val.created_at).getMinutes();
                        val.date = new Date(val.created_at).toLocaleDateString('id-ID', { month: 'short', year: 'numeric', day: 'numeric' });
                        return val;
                    }).sort(function (a, b) {
                        var keyA = new Date(a.created_at),
                            keyB = new Date(b.created_at);
                        // Compare the 2 dates
                        if (keyA < keyB) return 1;
                        if (keyA > keyB) return -1;
                        return 0;
                    });
                }
            })
                .catch((err) => this.riwayat = null)
                .finally(() => console.log('riwayat->loaded'));
        },
        getTimeline(level) {
            switch (level) {
                case '1':
                    this.timeline = 1;
                    break;
                case '4':
                    this.timeline = 2;
                    break;
                case '7':
                    this.timeline = 3;
                    break;
                case '10':
                    this.timeline = 4;
                    break;
                default:
                    break;
            }
        },
        urlCetakSuratKonfirmasi() {
            return this.$baseurl + '/api/cetak/' + this.kp.id + '/surat-konfirmasi';
        },
        urlCetakSuratPengantar() {
            return this.$baseurl + '/api/cetak/' + this.kp.id + '/surat-pengantar';
        },
        urlSuratTugasMahasiswa() {
            return this.$baseurl + '/api/cetak/' + this.kp.id + '/surat-tugas';
        },
        urlBeritaAcara() {
            return this.$baseurl + '/api/cetak/berita-acara';
        },
        generateRandomString(length) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

            let result = ' ';
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return '$' + result + '$';
        }
    }
}
</script>
<style>
ul {
    list-style-type: none;
}

.img-hero {
    position: absolute;
    right: 90px;
    bottom: 10px
}

@media only screen and (max-width: 767px) {
    .img-hero {
        right: 10px;
        bottom: 10px;
        opacity: 0.1;
    }
}
</style>
